import httpService from '@/modules/common/services/httpService';

const service = httpService.create(window.pov_config.VUE_APP_API_URL_GATEWAY);

export default service;
